import { getFileDownloadUrl } from './tenant'

const getImageUrl = (imageUri: string, addUri?: string) => {
    if (!imageUri) {
        return ''
    }

    if (addUri) {
        const lastIndex = imageUri.lastIndexOf('/')
        return `${getFileDownloadUrl()}${imageUri.substring(0, lastIndex)}/${addUri}/${imageUri.substring(
            lastIndex + 1,
            imageUri.length,
        )}`
    } else {
        return `${getFileDownloadUrl()}${imageUri}`
    }
}

export { getImageUrl }
